import { render, staticRenderFns } from "./TabNavLocal.vue?vue&type=template&id=14894ecd&scoped=true&"
import script from "./TabNavLocal.vue?vue&type=script&lang=js&"
export * from "./TabNavLocal.vue?vue&type=script&lang=js&"
import style0 from "./TabNavLocal.vue?vue&type=style&index=0&id=14894ecd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14894ecd",
  null
  
)

export default component.exports